import { render } from "./Activities.vue?vue&type=template&id=4d8687f7&scoped=true"
import script from "./Activities.vue?vue&type=script&lang=js"
export * from "./Activities.vue?vue&type=script&lang=js"

import "./Activities.vue?vue&type=style&index=0&id=4d8687f7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d8687f7"]])

export default __exports__